export default "__VITE_ASSET__CWRS6w43__"